export default {

    errors: { },

    get(field) {
         if (this.errors[field]) {
            return this.errors[field][0]
         }
    },

    record(errors) {
        this.errors = errors.errors
        window.location = '#app'
    },

    clear(field) {
        this.errors = {};
    },

    has(field) {
        return this.errors.hasOwnProperty(field)
    },

    any() {
        return Object.keys(this.errors).length > 0
    }
}
